import { render, staticRenderFns } from "./EditCategoryDefinition.vue?vue&type=template&id=0005f930&"
import script from "./EditCategoryDefinition.vue?vue&type=script&lang=js&"
export * from "./EditCategoryDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports